export default function useClubCirqueApi() {
	const store = useMsalStore();
	const { post } = useApi();

	// Call the Club Cirque API with the access token
	function getAccount() {
		if (!store.token) return;

		return post(
			"/api/GetAccount",
			{},
			{
				headers: {
					Authorization: `Bearer ${store.token}`,
					"Content-Type": "application/json",
				},
			}
		)
			.then(async (res) => {
				const { fetch: refreshSession } = useUserSession();
				await refreshSession();
				return res;
			})
			.catch(async (err) => {
				console.error("[useClubCirqueApi] - Error fetching account: ", err);
				const { clear: clearUserSession } = useUserSession();
				await clearUserSession();
				return null;
			});
	}

	async function registerAccount(payload) {
		if (!store.token || !payload) return;

		return post("/api/RegisterAccount", payload, {
			headers: {
				Authorization: `Bearer ${store.token}`,
				"Content-Type": "application/json",
			},
		})
			.then(async (res) => {
				const { fetch: refreshSession } = useUserSession();
				await refreshSession();
				return res;
			})
			.catch(async (err) => {
				console.error("[useClubCirqueApi] - Error registering account: ", err);
				const { clear: clearUserSession } = useUserSession();
				await clearUserSession();
				return null;
			});
	}

	return { getAccount, registerAccount };
}
